moment = require 'moment'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/header_warning_personal_boards_ownership'
{ Analytics, getScreenFromUrl } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class PersonalBoardsOwnershipBanner extends View
  className: 'header-banner mod-warning personal-boards-banner'

  initialize: ->
    @enterpriseName = @options.enterpriseName
    @ownDate = @options.ownDate
    @idEnterprise = @options.idEnterprise

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  events:
    'click .js-dismiss-personal-boards-ownership': 'dismiss'

  dismiss: (e) ->
    Util.stop(e)
    if @sendGASEvent
      Analytics.sendDismissedComponentEvent
        componentType: 'banner'
        componentName: 'personalBoardsOwnershipBanner'
        source: getScreenFromUrl()
        containers:
          enterprise:
            id: @idEnterprise

    @model.dismissPersonalBoardsOwnershipBanner =>
      @remove()

  render: ->
    @$el.html(
      template(
        enterpriseName: @enterpriseName,
        date: moment(@ownDate).locale(@model.getPref('locale') || 'en').format('LL'),
      )
    )
    if @sendGASEvent
      Analytics.sendViewedBannerEvent
        bannerName: 'personalBoardsOwnershipBanner'
        source: getScreenFromUrl()
        containers:
          enterprise:
            id: @idEnterprise

    @
